import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomValidatorService {
  /**
   * Function which is used to check whether the data in new and confirm password field are same.
   * @param form To store the data enterred in form.
   */
  validateAreEqual(form: any) {
    if (form.value.confirmPassword && form.value.newPassword) {
      return form.value.confirmPassword === form.value.newPassword
        ? null : form.get('confirmPassword').setErrors({ mismatch: true });
    }
    return null;
  }
}
